import { MailOutlined, SearchOutlined } from "@ant-design/icons";
import { Avatar, Button, Input } from "antd";
import React, { useMemo, useState } from "react";
import "./MyTeamWidget.css";

const defaultEmployees = [
  { id: "1", name: "Emily Rodriguez", position: "Product Manager", email: "emily.r@company.com", department: "Product" },
  { id: "2", name: "James Wilson", position: "UX Designer", email: "james.w@company.com", department: "Design" },
  { id: "3", name: "Anna Kim", position: "Frontend Developer", email: "anna.k@company.com", department: "Engineering" },
  { id: "4", name: "David Brown", position: "Backend Developer", email: "david.b@company.com", department: "Engineering" },
  { id: "5", name: "Lisa Chen", position: "QA Engineer", email: "lisa.c@company.com", department: "Engineering" },
];

function getInitials(name) {
  if (!name) return "?";
  return name
    .split(" ")
    .map((n) => n[0])
    .join("")
    .toUpperCase();
}

export function MyTeamWidget({ teamData }) {
  const [searchQuery, setSearchQuery] = useState("");
  const list = Array.isArray(teamData) ? teamData : defaultEmployees;

  const filteredEmployees = useMemo(() => {
    if (!searchQuery.trim()) return list;
    const q = searchQuery.toLowerCase();
    return list.filter(
      (emp) =>
        (emp.name && emp.name.toLowerCase().includes(q)) ||
        (emp.position && emp.position.toLowerCase().includes(q)) ||
        (emp.department && emp.department.toLowerCase().includes(q)) ||
        (emp.designation && emp.designation.toLowerCase().includes(q))
    );
  }, [list, searchQuery]);

  const handleEmail = (employee) => {
    const email = employee.email || employee.email_address;
    if (email) {
      window.location.href = `mailto:${email}`;
    }
  };

  return (
    <div className="my-team-widget">
      <div className="my-team-widget__card" bordered={false}>
        {/* <div className="my-team-widget__header">
          <TeamOutlined className="my-team-widget__header-icon" />
          <span className="my-team-widget__header-title">Staff Directory</span>
        </div> */}
        <div className="my-team-widget__body">
          <div className="my-team-widget__search-wrap">
            <Input
              placeholder="Search by name, position, or department..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              prefix={<SearchOutlined className="my-team-widget__search-icon" />}
              className="my-team-widget__search"
              allowClear
            />
          </div>
          <div className="my-team-widget__list">
            {filteredEmployees.length === 0 ? (
              <p className="my-team-widget__empty">
                No employees found matching your search.
              </p>
            ) : (
              filteredEmployees.map((employee) => {
                const name = employee.name || employee.employee_name || "";
                const position = employee.position || employee.designation || "";
                const department = employee.department || "";
                return (
                  <div
                    key={employee.id || employee.employee_id || employee.user_id || name}
                    className="my-team-widget__item"
                  >
                    <div className="my-team-widget__item-left">
                      <Avatar
                        size={40}
                        src={employee.imageUrl || employee.image_url || null}
                        className="my-team-widget__avatar"
                      >
                        {!employee.imageUrl && !employee.image_url
                          ? getInitials(name)
                          : null}
                      </Avatar>
                      <div className="my-team-widget__item-details">
                        <p className="my-team-widget__item-name">{name}</p>
                        <p className="my-team-widget__item-meta">
                          {[position, department].filter(Boolean).join(" • ")}
                        </p>
                      </div>
                    </div>
                    <Button
                      type="text"
                      size="small"
                      icon={<MailOutlined />}
                      className="my-team-widget__mail-btn"
                      onClick={() => handleEmail(employee)}
                    />
                  </div>
                );
              })
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default MyTeamWidget;
